import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { createElement } from 'react';
import classNames from 'classnames';

var ImageShadow = function ImageShadow(props) {
  var alt = props.alt,
      className = props.className,
      _props$shadowBlur = props.shadowBlur,
      shadowBlur = _props$shadowBlur === void 0 ? 20 : _props$shadowBlur,
      _props$shadowHover = props.shadowHover,
      shadowHover = _props$shadowHover === void 0 ? false : _props$shadowHover,
      _props$shadowRadius = props.shadowRadius,
      shadowRadius = _props$shadowRadius === void 0 ? 8 : _props$shadowRadius,
      src = props.src,
      style = props.style,
      _props$width = props.width,
      width = _props$width === void 0 ? 300 : _props$width;
  var cls = classNames('react-image-shadow', className, {
    'react-image-shadow-hover': shadowHover
  });
  return /*#__PURE__*/createElement("div", {
    className: cls,
    style: _objectSpread({
      width: "".concat(width, "px")
    }, style)
  }, /*#__PURE__*/createElement("img", {
    className: "react-image-shadow-img",
    src: src,
    alt: alt,
    width: width,
    style: {
      borderRadius: "".concat(shadowRadius, "px")
    }
  }), /*#__PURE__*/createElement("div", {
    className: "react-image-shadow-card",
    style: {
      backgroundImage: "url(".concat(src, ")"),
      borderRadius: "".concat(shadowRadius, "px"),
      filter: "blur(".concat(shadowBlur, "px)")
    }
  }));
};

export default ImageShadow;
